import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { Suspense } from 'react';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const LandingPage = lazy(() => import('../pages/landing/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Area pages
const AreasCoveredPage = lazy(() => import('../pages/areas-covered/page'));
const SacramentoAreaPage = lazy(() => import('../pages/areas/sacramento/page'));
const ElkGroveAreaPage = lazy(() => import('../pages/areas/elk-grove/page'));
const RosevilleAreaPage = lazy(() => import('../pages/areas/roseville/page'));
const FolsomAreaPage = lazy(() => import('../pages/areas/folsom/page'));
const CitrusHeightsAreaPage = lazy(() => import('../pages/areas/citrus-heights/page'));
const RanchoCordovaAreaPage = lazy(() => import('../pages/areas/rancho-cordova/page'));
const RocklinAreaPage = lazy(() => import('../pages/areas/rocklin/page'));
const DavisAreaPage = lazy(() => import('../pages/areas/davis/page'));
const WestSacramentoAreaPage = lazy(() => import('../pages/areas/west-sacramento/page'));
const CarmichaelAreaPage = lazy(() => import('../pages/areas/carmichael/page'));
const FairOaksAreaPage = lazy(() => import('../pages/areas/fair-oaks/page'));
const OrangevaleAreaPage = lazy(() => import('../pages/areas/orangevale/page'));
const NorthHighlandsAreaPage = lazy(() => import('../pages/areas/north-highlands/page'));
const AntelopeAreaPage = lazy(() => import('../pages/areas/antelope/page'));
const LincolnAreaPage = lazy(() => import('../pages/areas/lincoln/page'));
const AuburnAreaPage = lazy(() => import('../pages/areas/auburn/page'));
const GraniteBayAreaPage = lazy(() => import('../pages/areas/granite-bay/page'));
const ElDoradoHillsAreaPage = lazy(() => import('../pages/areas/el-dorado-hills/page'));
const NatomasAreaPage = lazy(() => import('../pages/areas/natomas/page'));
const LandParkAreaPage = lazy(() => import('../pages/areas/land-park/page'));
const ArdenArcadeAreaPage = lazy(() => import('../pages/areas/arden-arcade/page'));
const PlacervilleAreaPage = lazy(() => import('../pages/areas/placerville/page'));
const FlyerPage = lazy(() => import('../pages/flyer/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div></div>}><HomePage /></Suspense>,
  },
  {
    path: '/landing',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div></div>}><LandingPage /></Suspense>,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/areas-covered',
    element: <AreasCoveredPage />,
  },
  {
    path: '/areas/sacramento',
    element: <SacramentoAreaPage />,
  },
  {
    path: '/areas/elk-grove',
    element: <ElkGroveAreaPage />,
  },
  {
    path: '/areas/roseville',
    element: <RosevilleAreaPage />,
  },
  {
    path: '/areas/folsom',
    element: <FolsomAreaPage />,
  },
  {
    path: '/areas/citrus-heights',
    element: <CitrusHeightsAreaPage />,
  },
  {
    path: '/areas/rancho-cordova',
    element: <RanchoCordovaAreaPage />,
  },
  {
    path: '/areas/rocklin',
    element: <RocklinAreaPage />,
  },
  {
    path: '/areas/davis',
    element: <DavisAreaPage />,
  },
  {
    path: '/areas/west-sacramento',
    element: <WestSacramentoAreaPage />,
  },
  {
    path: '/areas/carmichael',
    element: <CarmichaelAreaPage />,
  },
  {
    path: '/areas/fair-oaks',
    element: <FairOaksAreaPage />,
  },
  {
    path: '/areas/orangevale',
    element: <OrangevaleAreaPage />,
  },
  {
    path: '/areas/north-highlands',
    element: <NorthHighlandsAreaPage />,
  },
  {
    path: '/areas/antelope',
    element: <AntelopeAreaPage />,
  },
  {
    path: '/areas/lincoln',
    element: <LincolnAreaPage />,
  },
  {
    path: '/areas/auburn',
    element: <AuburnAreaPage />,
  },
  {
    path: '/areas/granite-bay',
    element: <GraniteBayAreaPage />,
  },
  {
    path: '/areas/el-dorado-hills',
    element: <ElDoradoHillsAreaPage />,
  },
  {
    path: '/areas/natomas',
    element: <NatomasAreaPage />,
  },
  {
    path: '/areas/land-park',
    element: <LandParkAreaPage />,
  },
  {
    path: '/areas/arden-arcade',
    element: <ArdenArcadeAreaPage />,
  },
  {
    path: '/areas/placerville',
    element: <PlacervilleAreaPage />,
  },
  {
    path: '/flyer',
    element: <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div></div>}><FlyerPage /></Suspense>,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
